import { downloadByUrl } from '@insurancemenu/imenu-components-lib/dist/helpers/downloadByUrl';
import { discardDocument, editDocument, getDownloadDocumentURL } from 'api/operations/documentsService';
import { makeAutoObservable, runInAction } from 'mobx';
import ModalDelegate from 'store/general/modalDelegate';
import { Document } from 'types/documentsService';

interface ContextualProps {
  document: Document;
  refreshData: () => Promise<void>;
  setPageIsLoading: (status: boolean) => void;
  getExistingDocumentTypes: () => string[];
}

export default class ResponseDocumentDelegate {
  private _document: Document;
  private _refreshData: () => void;
  private readonly _setPageIsLoading: (status: boolean) => void;
  public getExistingDocumentTypes: () => string[];

  public warningModal = new ModalDelegate();

  public get document(): Document {
    return this._document;
  }

  public async downloadDocument(): Promise<void> {
    const downloadUrl = await getDownloadDocumentURL(this._document.id);
    downloadByUrl(downloadUrl);
  }

  public async removeDocument(): Promise<void> {
    await discardDocument(this._document.id);

    runInAction(() => {
      this._refreshData();
    });
  }

  public async editResponseDocument({ id, type, description }: Document): Promise<void> {
    this._setPageIsLoading(true);
    await editDocument({ documentId: id, type, description });

    runInAction(() => {
      this._refreshData();
    });
  }

  constructor({ document, refreshData, setPageIsLoading, getExistingDocumentTypes }: ContextualProps) {
    this._document = document;
    this._refreshData = refreshData;
    this._setPageIsLoading = setPageIsLoading;
    this.getExistingDocumentTypes = getExistingDocumentTypes;

    makeAutoObservable(this, {}, { autoBind: true });
  }
}
